import styled from 'styled-components';

import { BasicSubtitle, SmallParagraph } from '@genially/design-system';

import { PANEL_SURFACE } from '../../../common/panelColors';

export const Wrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: size.units(2),
  padding: size.units(2),
  borderRadius: size.units(1),
  backgroundColor: PANEL_SURFACE,
}));

export const ChartWrapper = styled.div(({ theme: { size } }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: size.units(2),
}));

export const QuestionSubtitle = styled(BasicSubtitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));

export const LegendsWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.units(2),
  alignSelf: 'flex-start',
}));

export const LegendWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: size.units(1.5),
}));

interface MarkerProps {
  $color: string;
}

export const Marker = styled.div<MarkerProps>(({ theme: { size }, $color }) => ({
  minWidth: size.units(2),
  height: size.units(2),
  backgroundColor: $color,
}));

export const Legend = styled(SmallParagraph)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));
